// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".svg-icon{display:inline-flex;align-self:center}.svg-icon svg{height:1em;width:1em;fill:currentColor}.svg-icon.baseline svg{top:.125em;position:relative}.svg-icon.right svg{margin-right:10px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
